import { Icon as IconType } from 'iconsax-react';

import Button from '@/components/Button';
import Link from '@/components/Link';

import styles from '../ProfileConfigureTotp.module.scss';

export const CONFIGURE_TOTP_PATH = '/api/account/configure-totp';

interface ConfigureLinkProps {
  buttonText: string;
  variant: 'white' | 'dashed';
  icon: IconType;
  ariaLabel?: string;
  fullWidth?: boolean;
}

const ConfigureLink: React.FC<ConfigureLinkProps> = ({
  buttonText,
  variant,
  icon: Icon,
  ariaLabel,
  fullWidth = false,
}) => (
  <Link
    href={CONFIGURE_TOTP_PATH}
    underline={false}
    disableHover
    isInline
    className={styles.buttonLink}
    {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
  >
    <Button
      text={buttonText}
      variant={variant}
      {...(variant === 'white'
        ? { RightIcon: Icon }
        : { LeftIcon: Icon, fullWidth })}
    />
  </Link>
);

export default ConfigureLink;
